module.exports = __webpack_public_path__ + "media/newstyle/images/icon-full-cover-035b5881dc26d5ac1c6ca72b32957487.svg";